import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';

// lib
import formatPhoneNumber from '../../../lib/formatPhoneNumber';
import Button from '../../shared/form/_Button';

const IndexRow = function({ rep, onRepBlock, onRepUnblock  }) {
  return (
    rep.size > 0 && <div className='manager-reps-table__row'>
      <div className='manager__reps-table__column manager-reps-table__row--name'>
        { rep.get('name') }
      </div>
      <div className='manager__reps-table__column manager-reps-table__row--company'>
        { rep.get('company') }
      </div>
      <div className='manager__reps-table__column manager-reps-table__row--products'>
        { rep.get('products') }
      </div>
      <div className='manager__reps-table__column manager-reps-table__row--phone'>
        { formatPhoneNumber(rep.get('phoneNumber')) }
      </div>
      <div className='manager__reps-table__column manager-reps-table__row--email'>
        { rep.get('email') }
      </div>
      <div className='manager__reps-table__column manager-reps-table__row--button'>
        {rep.get('blocked') ?
          <Button className={ 'manager-reps__button manager-reps__button--unblock' } onClick={ onRepUnblock(rep.get('id')) }>unblock</Button> :
          <Button className={ 'manager-reps__button manager-reps__button--block' } onClick={ onRepBlock(rep.get('id')) }>block</Button>}
      </div>
    </div>
  );
};

IndexRow.propTypes = {
  onRepBlock: PropTypes.func.isRequired,
  onRepUnblock: PropTypes.func.isRequired,
  rep: PropTypes.instanceOf(Immutable.Map)
};

export default IndexRow;



// WEBPACK FOOTER //
// ./app/components/managers/reps/_IndexRow.jsx